import { defineComponent as t, openBlock as n, createBlock as r, unref as a, mergeProps as m, withCtx as d, createElementVNode as p } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconCommentSolvedFilled",
  __name: "IconCommentSolvedFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const l = o;
    return (c, e) => (n(), r(a(i), m(l, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M18.5 2.25a3.25 3.25 0 0 1 3.25 3.25v9a3.25 3.25 0 0 1-3.25 3.25h-6.237l-4.794 3.836A.75.75 0 0 1 6.25 21v-3.25H5.5a3.25 3.25 0 0 1-3.25-3.25v-9A3.25 3.25 0 0 1 5.5 2.25h13m-2.47 4.72a.75.75 0 0 0-1.061 0l-4.47 4.47-1.468-1.468a.75.75 0 0 0-1.06 1.06l1.998 1.998a.75.75 0 0 0 1.06 0l5-5a.75.75 0 0 0 0-1.06",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
